import { PlayerService } from './../../player/services/player.service';
import { Component, OnInit, AfterViewInit, ChangeDetectorRef, } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { SongsService, ScrollService } from '../../api';
import { timeInterval } from "rxjs/operator/timeInterval";
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-song-detail-page',
  templateUrl: './song-detail-page.component.html',
  styleUrls: ['./song-detail-page.component.css']
})
export class SongDetailPageComponent implements OnInit, AfterViewInit {
  private song: any=[];
  @BlockUI() blockUI: NgBlockUI;
  private notfound: boolean = false;

  constructor(private route: ActivatedRoute, private router: Router, private songService: SongsService, private scrollService: ScrollService, private cdRef: ChangeDetectorRef, private playerService: PlayerService) {
    this.scrollService.toggleProgressBar(true);
  }

  ngOnInit() {
    if (screen.width <= 320) {
      var btn = document.getElementById("123");
      btn.click();
    }
    this.route.params
      .switchMap((params: Params) => this.songService.getSongDetailBySlug(params['songSlug']))
      .subscribe((res) => {
        this.song = res;
        if(!this.song) {
          this.notfound=true;
        }
        this.cdRef.detectChanges();
        this.scrollService.toggleProgressBar(false);
      },
      (error) => {
        console.log(error);
      });
      
    this.route.params.subscribe((params) => {
      if(params['user_id']){
        localStorage.setItem('share_id',params['user_id']);
        localStorage.setItem('download_share_id',params['user_id']);
      }
    });
    // to check if the url is for share purpose
    this.route.queryParams.subscribe((params) => {
      if(params['share']) {
        // to slide the menu and enable full page view
        var btn = document.getElementById("123");
        btn.click();
        // to adjust the volume
        setTimeout(() => {
          this.playerService.adjustVolumeSlider(50);
        }, 2000);
      }
    });

    this.blockUI.start('Loading, please wait...');
    setTimeout(() => {
      this.blockUI.stop();
    }, 2000);
  }


  ngAfterViewInit() {
  }

  autoPlay() {
    setTimeout(() => {
      if(this.song.length>0) {
        let a = document.getElementById('playSong');
        if(a!=null) {
          a.click();
        }
      }
    }, 3000);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/songs/song-detail-page/song-detail-page.component.ts